import { Nav } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import { HorizontalStack, Icon } from '@ztechapps/webui.util'
import React from 'react'

export type NavigationLinkProps = { href: string; title: string; icon: string }
export const NavigationLink = (props: NavigationLinkProps) => {
  return (
    <Nav.Item as="li">
      <NavLink
        className={({ isActive }) => {
          const activeStyle = isActive ? '' : 'collapsed'
          return `${activeStyle} nav-link `
        }}
        to={props.href ?? '/'}
      >
        <HorizontalStack gap={1}>
          <Icon name={props.icon} />
          <div>{props.title}</div>
        </HorizontalStack>
      </NavLink>
    </Nav.Item>
  )
}
